import m from "../../geodata/es2015/bruneiDarussalamLow";
window.am4geodata_bruneiDarussalamLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bruneiDarussalamLow.js
// module id = null
// module chunks = 